/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { User } from '@shared/models';

export interface AuthState {
  authInit: boolean;
  authenticated: boolean;
  pending: boolean;
  error: string;
  user?: User;
}

export const initialState: AuthState = {
  authInit: false,
  authenticated: false,
  pending: false,
  error: null,
  user: null
};
